export default {"src":"/_next/static/media/stressMotivationMobile.37dfe7b0.svg","height":233,"width":272,"blurWidth":0,"blurHeight":0};